import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'

const vue = new Vue()

const state = {
  reservoirAreaList: {rows: []},
  reservoirAreaMark: 0
}

const actions = {
  [types.GETRESERVOIRAREALIST] (context, params) {
    http.fetch('/api/area/ycAreaPage', params).then(data => {
      context.commit(types.GETRESERVOIRAREALIST, data)
    })
  },
  [types.SAVERESERVOIRAREA] (context, params) {
    http.fetch('/api/area/saveArea', params).then(data => {
      context.commit(types.SAVERESERVOIRAREA, data)
    })
  },
  [types.DELRESERVOIRAREA] (context, params) {
    http.fetch('/api/area/deleteArea', params).then(data => {
      context.commit(types.DELRESERVOIRAREA, data)
    })
  },

  [types.GETRESERVOIRAREADETAILS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/area/seleceById', params).then(data => {
        context.commit(types.GETRESERVOIRAREADETAILS, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const mutations = {
  [types.GETRESERVOIRAREALIST] (state, data) {
    state.reservoirAreaList = {
      rows: data.obj
    }
  },
  [types.SAVERESERVOIRAREA] (state, data) {
    if (data.code === 200) {
      state.reservoirAreaMark = 1
      vue.$message({
        showClose: true,
        message: '保存成功',
        type: 'success'
      })
    }
  },
  [types.DELRESERVOIRAREA] (state, data) {
    if (data.code === 200) {
      state.reservoirAreaMark = 1
      vue.$message({
        showClose: true,
        message: '删除成功',
        type: 'success'
      })
    }
  },
  [types.GETRESERVOIRAREADETAILS] (state, data) {
  }

}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/reservoirAreaManage/index.js